import { ApiBaseData, ApiGetBusinessPartnerResponse } from '@ibe/api';
import { ApiService, LoggerFactory } from '@ibe/services';
import { action, observable, runInAction, makeObservable } from 'mobx';
import ServiceListStore from '../../SubModules/ServiceList/ServiceListStore';

class AgencyInfoStore extends ServiceListStore {
  private logger = LoggerFactory.get('AgencyInfoStore');

  isLoading = false;

  error: string | null = null;

  countries: ApiBaseData[] = [];

  languages: ApiBaseData[] = [];

  currencies: ApiBaseData[] = [];

  businessPartner: ApiGetBusinessPartnerResponse | null = null;

  constructor(private api: ApiService) {
    super();

    makeObservable(this, {
      isLoading: observable,
      error: observable,
      countries: observable,
      languages: observable,
      currencies: observable,
      businessPartner: observable,
      setIsLoading: action,
      loadCountries: action,
      loadBusinessPartner: action
    });
  }

  setIsLoading(b: boolean): void {
    this.isLoading = b;
  }

  async loadCountries(): Promise<void> {
    let countries: ApiBaseData[] = [];
    let error: string | null = null;
    try {
      countries = await this.api.getAllCountries();
    } catch (e) {
      this.logger.warn(e);
      error = 'We could not find countries';
    }
    runInAction(() => {
      this.error = error;
      this.countries = countries;
    });
  }

  async loadLanguages(): Promise<void> {
    let languages: ApiBaseData[];
    let error: string | null = null;
    try {
      languages = await this.api.getAllLanguages();
    } catch (e) {
      this.logger.warn(e);
      error = 'We could not find languages';
    }
    runInAction(() => {
      this.error = error;
      this.languages = languages;
    });
  }

  async loadCurrencies(): Promise<void> {
    let currencies: ApiBaseData[];
    let error: string | null = null;
    try {
      currencies = await this.api.getAllCurrencies();
    } catch (e) {
      this.logger.warn(e);
      error = 'We could not find currencies';
    }
    runInAction(() => {
      this.error = error;
      this.currencies = currencies;
    });
  }

  async loadBusinessPartner(): Promise<void> {
    let businessPartner: ApiGetBusinessPartnerResponse;
    let error: string | null = null;
    try {
      businessPartner = await this.api.getBusinessPartner();
    } catch (e) {
      this.logger.warn(e);
      error = 'Could not fetch business partner';
    }
    runInAction(() => {
      this.error = error;
      this.businessPartner = businessPartner;
    });
  }
}

export default AgencyInfoStore;
